import { selectBrand } from "Services/state/brand";
import { reduxStore } from "Services/state/Storage";

import { loadRegalAuthProfile } from "./RegalAuthContext";

/**
 * Brand slug from the current `regal-sid-profile` cookie (reads live from `document.cookie`).
 */
export function cookieBrandSlugFromProfile(): string | undefined {
    return loadRegalAuthProfile()?.brand.slug;
}

/**
 * Reads the session cookie and Redux once; true when the encoded brands disagree.
 */
export function getCookieReduxBrandDrift(): boolean {
    const cookieSlug = cookieBrandSlugFromProfile();
    const reduxSlug = selectBrand(reduxStore.getState())?.slug;
    return !!reduxSlug && !!cookieSlug && cookieSlug !== reduxSlug;
}
